import Icon from '@components/icon';
import Link from '@components/link';
import { observer } from 'mobx-react-lite';

import { searchInstruction, searchRutubeGuide } from 'constants/pages';
import { useStore } from 'hooks/useStore';
import { interpolate } from 'utils/string/format';

import css from './Instructions.module.css';

const Instructions = () => {
  const {
    app: { i18n, env },
  } = useStore();

  return (
    <div className={css.container}>
      <Link
        before={<Icon name="ic_rutube" size="s" />}
        href={searchRutubeGuide}
        rel="noopener noreferrer"
        target="_blank"
        theme="gray"
      >
        {i18n.app.howToSearchOnATI}
      </Link>

      <Link
        before={<Icon className={css.icon} color="var(--glz-color-primary)" name="ic_doc" size="s" />}
        href={interpolate(searchInstruction, { env })}
        rel="noopener noreferrer"
        target="_blank"
        theme="gray"
        title={`${i18n.app.searchInstruction.firstPart} ${i18n.app.searchInstruction.secondPart}`}
      >
        {i18n.app.searchInstruction.firstPart}{' '}
        <span className={css.instructionSecondPart}>{i18n.app.searchInstruction.secondPart}</span>
      </Link>
    </div>
  );
};

const connected = observer(Instructions);

export { connected as Instructions };
